import { z } from "zod";
export const RecipeDecisionPhaseSchema = z.enum([
    "INTENT_PROFILE",
    "LENS_RESOLUTION",
    "STRATEGY_RESOLUTION",
    "REFERENCE_RESOLUTION",
    "SECTION_ORDER",
    "COMPONENT_SELECTION",
    "MEDIA_RESOLUTION",
    "FALLBACK",
    "QUALITY_FLOOR",
]);
export const RecipeDecisionLogEntrySchema = z
    .object({
    decisionId: z.string().min(1),
    phase: RecipeDecisionPhaseSchema,
    reasonCode: z.string().min(1),
    inputRefs: z.array(z.string().min(1)).default([]),
    selectedValue: z.string().min(1),
    fallback: z.boolean().default(false),
    blocking: z.boolean().default(false),
    clientSafeSummary: z.string().min(1),
})
    .strict();
export const RecipeDecisionLogV1Schema = z
    .object({
    schemaVersion: z.literal("recipe-decision-log.v1.0"),
    plannerVersion: z.string().min(1),
    entries: z.array(RecipeDecisionLogEntrySchema),
})
    .strict();
//# sourceMappingURL=recipe-decision-log.js.map